/**
 * Dashboard App Entry Point
 * 
 * Initializes the React application for the Before After Image Slider Dashboard.
 */

import { createRoot, render } from '@wordpress/element';
import Dashboard from './components/dashboard/Dashboard';

/**
 * Main App component
 */
function App() {
    return <Dashboard />;
}

// Wait for DOM to be ready
document.addEventListener(
    'DOMContentLoaded',
    function() {
        // Check if jQuery is available through our global reference
        if (window.cocaBaisJQuery) {
            // Make jQuery available to components if needed
            window.$ = window.cocaBaisJQuery;
        }
        
        const dashboardContainer = document.getElementById('coca-bais-dashboard-app');
        
        if (dashboardContainer) {
            // render components in reactjs 18
            if (typeof createRoot === 'function') {
                const root = createRoot(dashboardContainer);
                root.render(<App />);
            } else {
                // render components in reactjs 17
                render(<App />, dashboardContainer);
            }
        }
    },
    false
);
